/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { HubbleShipmentFiltersQuery } from "./HubbleShipmentFiltersQuery";
import {
  HubbleShipmentFiltersQueryFromJSON,
  HubbleShipmentFiltersQueryFromJSONTyped,
  HubbleShipmentFiltersQueryToJSON,
  HubbleShipmentFiltersQueryToJSONTyped,
} from "./HubbleShipmentFiltersQuery";

/**
 *
 * @export
 * @interface CreateExperimentRequest
 */
export interface CreateExperimentRequest {
  /**
   *
   * @type {string}
   * @memberof CreateExperimentRequest
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CreateExperimentRequest
   */
  purpose: string;
  /**
   *
   * @type {Array<string>}
   * @memberof CreateExperimentRequest
   */
  shipmentIds: Array<string>;
  /**
   *
   * @type {HubbleShipmentFiltersQuery}
   * @memberof CreateExperimentRequest
   */
  filters?: HubbleShipmentFiltersQuery | null;
  /**
   *
   * @type {string}
   * @memberof CreateExperimentRequest
   */
  companyId?: string | null;
}

/**
 * Check if a given object implements the CreateExperimentRequest interface.
 */
export function instanceOfCreateExperimentRequest(
  value: object,
): value is CreateExperimentRequest {
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("purpose" in value) || value["purpose"] === undefined) return false;
  if (!("shipmentIds" in value) || value["shipmentIds"] === undefined)
    return false;
  return true;
}

export function CreateExperimentRequestFromJSON(
  json: any,
): CreateExperimentRequest {
  return CreateExperimentRequestFromJSONTyped(json, false);
}

export function CreateExperimentRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CreateExperimentRequest {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"],
    purpose: json["purpose"],
    shipmentIds: json["shipmentIds"],
    filters:
      json["filters"] == null
        ? undefined
        : HubbleShipmentFiltersQueryFromJSON(json["filters"]),
    companyId: json["companyId"] == null ? undefined : json["companyId"],
  };
}

export function CreateExperimentRequestToJSON(
  json: any,
): CreateExperimentRequest {
  return CreateExperimentRequestToJSONTyped(json, false);
}

export function CreateExperimentRequestToJSONTyped(
  value?: CreateExperimentRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    purpose: value["purpose"],
    shipmentIds: value["shipmentIds"],
    filters: HubbleShipmentFiltersQueryToJSON(value["filters"]),
    companyId: value["companyId"],
  };
}
